import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | 'contact' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const [showEmail, setShowEmail] = useState(false);
  return <>
      <footer className="bg-bg py-10 px-6 border-t border-border text-center pb-28 md:pb-10" data-id="element-24">
        <div className="max-w-[640px] mx-auto text-xs text-gray" data-id="element-25">
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 mb-4" data-id="element-26">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-charcoal transition-colors" data-id="element-27">
              Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-charcoal transition-colors" data-id="element-28">
              Términos
            </button>
            <button onClick={() => setActiveModal('contact')} className="hover:text-charcoal transition-colors" data-id="element-29">
              Contacto
            </button>
          </div>
          <p data-id="element-30">
            © {new Date().getFullYear()} El Permiso. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Modal overlay */}
      <AnimatePresence data-id="element-31">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-charcoal/50 backdrop-blur-sm z-[60] flex items-center justify-center p-6" onClick={() => setActiveModal(null)} data-id="element-32">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} transition={{
          duration: 0.2,
          ease: 'easeOut'
        }} className="bg-white rounded-xl shadow-xl max-w-lg w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-33">
              <div className="sticky top-0 bg-white border-b border-border px-6 py-4 flex items-center justify-between rounded-t-xl" data-id="element-34">
                <h3 className="font-semibold text-charcoal text-base" data-id="element-35">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : activeModal === 'terms' ? 'Términos y Condiciones' : 'Contacto'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-gray hover:text-charcoal transition-colors p-1" aria-label="Cerrar" data-id="element-36">
                  <X className="w-5 h-5" data-id="element-37" />
                </button>
              </div>

              <div className="px-6 py-6 text-sm text-gray leading-relaxed space-y-4" data-id="element-38">
                {activeModal === 'privacy' ? <>
                    <p className="font-medium text-charcoal" data-id="element-39">
                      Última actualización:{' '}
                      {new Date().toLocaleDateString('es-ES', {
                  month: 'long',
                  year: 'numeric'
                })}
                    </p>
                    <p data-id="element-40">
                      En El Permiso nos tomamos tu privacidad en serio. Esta
                      política describe cómo recopilamos, usamos y protegemos tu
                      información personal.
                    </p>
                    <h4 className="font-semibold text-charcoal pt-2" data-id="element-41">
                      1. Datos que recopilamos
                    </h4>
                    <p data-id="element-42">
                      Únicamente recopilamos los datos necesarios para procesar
                      tu compra: nombre, dirección de email y datos de pago. El
                      procesamiento del pago se realiza a través de Shopify, que
                      cumple con los estándares PCI-DSS.
                    </p>
                    <h4 className="font-semibold text-charcoal pt-2" data-id="element-43">
                      2. Uso de los datos
                    </h4>
                    <p data-id="element-44">
                      Tus datos se utilizan exclusivamente para enviarte el
                      producto digital adquirido y para comunicaciones
                      relacionadas con tu compra. No vendemos, alquilamos ni
                      compartimos tus datos con terceros con fines comerciales.
                    </p>
                    <h4 className="font-semibold text-charcoal pt-2" data-id="element-45">
                      3. Almacenamiento y seguridad
                    </h4>
                    <p data-id="element-46">
                      Tus datos se almacenan de forma segura en los servidores
                      de Shopify. Implementamos medidas de seguridad técnicas y
                      organizativas para proteger tu información.
                    </p>
                    <h4 className="font-semibold text-charcoal pt-2" data-id="element-47">
                      4. Tus derechos
                    </h4>
                    <p data-id="element-48">
                      Puedes solicitar el acceso, rectificación o eliminación de
                      tus datos personales en cualquier momento escribiendo a
                      electronicecomjj@gmail.com.
                    </p>
                    <h4 className="font-semibold text-charcoal pt-2" data-id="element-49">
                      5. Cookies
                    </h4>
                    <p data-id="element-50">
                      Utilizamos cookies esenciales para el funcionamiento del
                      sitio y cookies analíticas para mejorar la experiencia.
                      Puedes desactivarlas en la configuración de tu navegador.
                    </p>
                  </> : activeModal === 'terms' ? <>
                    <p className="font-medium text-charcoal" data-id="element-51">
                      Última actualización:{' '}
                      {new Date().toLocaleDateString('es-ES', {
                  month: 'long',
                  year: 'numeric'
                })}
                    </p>
                    <p data-id="element-52">
                      Al adquirir El Permiso, aceptas los siguientes términos y
                      condiciones de uso.
                    </p>
                    <h4 className="font-semibold text-charcoal pt-2" data-id="element-53">
                      1. Producto digital
                    </h4>
                    <p data-id="element-54">
                      El Permiso es un producto digital (guía en formato
                      PDF/slides) que se entrega mediante descarga inmediata
                      tras el pago. Al tratarse de contenido digital, no se
                      admiten devoluciones una vez realizada la descarga.
                    </p>
                    <h4 className="font-semibold text-charcoal pt-2" data-id="element-55">
                      2. Uso personal
                    </h4>
                    <p data-id="element-56">
                      La guía es para uso personal e intransferible. Queda
                      prohibida su reproducción, distribución o reventa total o
                      parcial sin autorización expresa.
                    </p>
                    <h4 className="font-semibold text-charcoal pt-2" data-id="element-57">
                      3. Contenido educativo
                    </h4>
                    <p data-id="element-58">
                      El contenido de El Permiso tiene carácter educativo e
                      informativo. No constituye asesoramiento médico,
                      psicológico ni terapéutico profesional. Si necesitas ayuda
                      profesional, consulta con un especialista cualificado.
                    </p>
                    <h4 className="font-semibold text-charcoal pt-2" data-id="element-59">
                      4. Precio y pago
                    </h4>
                    <p data-id="element-60">
                      El precio del producto es de 7€ (IVA incluido). El pago se
                      procesa de forma segura a través de Shopify. Es un pago
                      único, sin suscripciones ni cargos recurrentes.
                    </p>
                    <h4 className="font-semibold text-charcoal pt-2" data-id="element-61">
                      5. Contacto
                    </h4>
                    <p data-id="element-62">
                      Para cualquier consulta relacionada con tu compra, puedes
                      escribirnos a electronicecomjj@gmail.com.
                    </p>
                  </> : <>
                    <p className="text-base text-charcoal font-medium" data-id="element-63">
                      ¿Tienes alguna duda o necesitas ayuda con tu compra?
                    </p>
                    <p data-id="element-64">
                      Escríbenos y te responderemos lo antes posible.
                      Normalmente contestamos en menos de 24 horas.
                    </p>
                    <div className="bg-bg-alt rounded-lg p-4 mt-2" data-id="element-65">
                      <p className="text-xs text-gray uppercase tracking-wider mb-2 font-medium" data-id="element-66">
                        Email
                      </p>
                      <a href="mailto:electronicecomjj@gmail.com" className="text-navy hover:text-navy-dark transition-colors font-semibold text-base" data-id="element-67">
                        electronicecomjj@gmail.com
                      </a>
                    </div>
                  </>}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}